<template>
  <div class="wrapper">
      <h1>欢迎登录仓颉系统平台</h1>
  </div>
</template>
